import styles from './css/styles.css'
 
const codes = {
  br: 'Brasil',
  us: 'USA',
  pt: 'Portugal',
  en: 'Inglaterra'
}
 
export { styles, codes }